/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Last_Modified_HeaderInputs */



/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Explorer_Table_Last_Modified_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_last_modified_header = /** @type {((inputs?: Explorer_Table_Last_Modified_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Last_Modified_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Derniere modification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Änderung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultima modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последнее изменение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Última modificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最后修改日期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最終更新日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम बार संशोधित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Última modificação")
	return /** @type {LocalizedString} */ ("Last Modified")
});